// https://developers.google.com/tag-manager/quickstart

export function useTagManager() {
  const dataLayerName = 'dataLayer';
  const configuration = ref(useConfiguration());
  const gtmTagId = configuration.value.GTM_TAG_ID;

  const noScriptUrl = `https://www.googletagmanager.com/ns.html?id=${gtmTagId}`;

  const snippets = {
    getNoScript: function (): string {
      return `<iframe src="${noScriptUrl} height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    },
    getScript: function (): string {
      return `(function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
      })
      (window,document,'script','${dataLayerName}','${gtmTagId}');`;
    },
  };

  const tagManager = {
    noScript: function () {
      const noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.getNoScript();
      return noscript;
    },
    script: function () {
      const script = document.createElement('script');
      script.innerHTML = snippets.getScript();
      return script;
    },
  };

  const initializeGTM = () => {
    if (!gtmTagId) {
      console.log('GTM Tag ID not found');
      return;
    }

    if (document.querySelector(`script[src*="${gtmTagId}"]`)) {
      console.log('GTM script already exists');
      return;
    }

    // Add the GTM <script> to the <head>
    document.head.insertBefore(tagManager.script(),document.head.firstChild);

    // Add the GTM <noscript> to the <body> as first child
    document.body.insertBefore(tagManager.noScript(), document.body.firstChild);
  };

  onMounted(() => {
    initializeGTM();
  });

  return {
    initializeGTM,
  };
}
